import { ApiPromise, WsProvider } from '@polkadot/api';
import { KeyringPair } from '@polkadot/keyring/types';
import { InjectedExtension } from '@polkadot/extension-inject/types';
import { RuntimeSpec } from '../../types.js';

export interface EstablishedConnection {
  api: ApiPromise;
  provider: WsProvider;
  runtimeSpec: RuntimeSpec;
}

export interface AccountConnection extends EstablishedConnection {
  accounts: Map<string, KeyringPair>;
}

export interface WalletConnection extends EstablishedConnection {
  injector: InjectedExtension;
  accountAddress: string;
}
